export class Popup {
  constructor(form) {
    if (form) {
      this.id = form.id;
      this.btn1 = form.buttonTypeConfig[0] || {
        type: null,
        name: "",
        url: "",
      };
      this.btn2 = form.buttonTypeConfig[1] || {
        type: null,
        name: "",
        url: "",
      };
      // this.buttonTypeConfig = form.buttonTypeConfig;
      this.beginTime = form.beginTime;
      this.endTime = form.endTime;
      this.popUpImg = form.popUpImg;
      this.popUpName = form.popUpName;
      this.popUpType = form.popUpType;
    } else {
      this.clear();
    }
  }

  clear() {
    this.id = "";
    // this.buttonTypeConfig = [
    //   {
    //     type: null,
    //     name: "",
    //     url: "",
    //   },
    //   {
    //     type: null,
    //     name: "",
    //     url: "",
    //   },
    // ];
    this.btn1 = {
      type: null,
      name: "",
      url: "",
    };
    this.btn2 = {
      type: null,
      name: "",
      url: "",
    };
    this.beginTime = "";
    this.endTime = "";
    this.popUpImg = "";
    this.popUpName = "";
    this.popUpType = "";
  }
}
